import { useContext } from 'react';
import { useStore } from 'zustand';

import type { CalendarTimeframeStore } from './calendar.types.js';
import type { DateTimePickerValueStore } from './dateTimePicker.types.js';
import type { DateTimeRangePickerTimeframeStore } from './dateTimeRangePicker.types.js';
import type { TimeframeSelectorStore } from './timeframeSelector.types.js';
import {
  CalendarStoreCtx,
  DateTimePickerStoreCtx,
  DateTimeRangePickerStoreCtx,
  TimeframeSelectorStoreCtx,
} from './timeframeStoreProvider.js';

/** @internal */
export function useCalendarStore<T>(
  selector: (state: CalendarTimeframeStore) => T,
): T {
  const store = useContext(CalendarStoreCtx);
  if (!store) {
    throw new Error(
      'useCalendarStore must be used within a CalendarStoreProvider',
    );
  }
  return useStore(store, selector);
}

/** @internal */
export function useDateTimePickerStore<T>(
  selector: (state: DateTimePickerValueStore) => T,
): T {
  const store = useContext(DateTimePickerStoreCtx);
  if (!store) {
    throw new Error(
      'useDateTimePickerStore must be used within a DateTimePickerStoreProvider',
    );
  }
  return useStore(store, selector);
}

/** @internal */
export function useDateTimeRangePickerStore<T>(
  selector: (state: DateTimeRangePickerTimeframeStore) => T,
): T {
  const store = useContext(DateTimeRangePickerStoreCtx);
  if (!store) {
    throw new Error(
      'useDateTimeRangePickerStore must be used within a DateTimeRangePickerStoreProvider',
    );
  }
  return useStore(store, selector);
}

/** @internal */
export function useTimeframeSelectorStore<T>(
  selector: (state: TimeframeSelectorStore) => T,
): T {
  const store = useContext(TimeframeSelectorStoreCtx);
  if (!store) {
    throw new Error(
      'useTimeframeSelectorStore must be used within a TimeframeSelectorStoreProvider',
    );
  }
  return useStore(store, selector);
}
